import styled from "styled-components";
import { ColorsInterface } from "@/theme/colors";

/**
 * H3 Component
 */

export const H3 = styled.h3<ColorsInterface>`
  ${({ color = "black", theme }) => `
  color: ${theme.Colors[color]};
  font-family: ${theme.Fonts.ttNormsProBold};
  font-size: 26px;
  line-height: 36px;
  `}
`;
